import {css} from 'lit';
export const styles = css`:host {
  --font-size-base: 12px;
  --month-color: var(--orange-500);
  --name-bg: var(--secondary-500);

  display: block;
  width: 50px;
  padding: 4px;
  font-size: var(--font-size-base);
  text-align: center;
  line-height: 1;
}

.name {
  background-color: var(--name-bg);
  padding: 2px;
  margin: -4px -4px 4px;
  color: #fff;
  text-transform: uppercase;
}

.day {
  font-size: 1.3em;
}

.month {
  margin-top: -1px;
  margin-bottom: 1px;
  color: var(--month-color);
  text-transform: uppercase;
}

:host([currentDay]) {
  --name-bg: var(--primary-500);
}

:host([theme='white']) {
  background-color: #fff;
}

:host([theme='gray']) {
  background-color: var(--gray-000);
}
`;
export default styles;
